import dayjs from 'dayjs'
import ja from 'dayjs/locale/ja'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Tokyo')
dayjs.locale(ja)

export const getEndYearMonthDay = () => {
  const endYearMonth = dayjs().utc().startOf('day').subtract(1, 'day')
  return {
    endYear: endYearMonth.year(),
    endMonth: endYearMonth.month() + 1,
    endDay: endYearMonth.date()
  }
}

export const generateYearList = () => {
  const startYear = pastPageStartYear
  const { endYear, endMonth } = getEndYearMonthDay()
  const yearList = []
  for (let year = startYear; year <= endYear; year++) {
    if (year === endYear) {
      yearList.push({
        year: `${year}`,
        maxMonth: endMonth
      })
      continue
    }
    yearList.push({
      year: `${year}`
    })
  }
  return yearList
}
